import React from 'react';
import PropTypes from 'prop-types';
import { Body } from '@edreamsodigeo/prisma-design-system';
import Duration from '../../../../Shared/Duration';

export interface SegmentDurationProps {
  duration: number;
}

const SegmentDuration: React.FC<SegmentDurationProps> = ({ duration }) => {
  return (
    <Body type="xSmall" color={'neutral.70'}>
      <Duration durationInMinutes={duration} />
    </Body>
  );
};

SegmentDuration.propTypes = {
  duration: PropTypes.number.isRequired,
};

export default SegmentDuration;
